import { render, staticRenderFns } from "./hanjieyuegz.vue?vue&type=template&id=63e36873&scoped=true&"
import script from "./hanjieyuegz.vue?vue&type=script&lang=js&"
export * from "./hanjieyuegz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e36873",
  null
  
)

export default component.exports